module.exports = __webpack_public_path__ + "static/img/caiwubiaoxian1.d8992b1c.png";